export default __webpack_public_path__ + "static/media/arrow_drop_down.f8fae707.svg";